<script>
import options from './NykButton.options'
export default options
</script>

<template>
  <component
    :is="componentTag"
    :type="as === 'button' ? type : undefined"
    :href="as === 'link' ? href : undefined"
    :target="as === 'link' ? target : undefined"
    :rel="as === 'link' && target === '_blank' ? 'noopener noreferrer' : undefined"
    :autofocus="autofocus"
    :class="buttonClasses"
    :aria-label="ariaLabel || undefined"
    :aria-describedby="ariaDescribedby || undefined"
    :disabled="as === 'button' ? disabled : undefined"
    :aria-disabled="as === 'link' && disabled ? 'true' : undefined"
    @click="handleClick"
    @keydown="handleKeydown"
  >
    <span v-if="$slots.icon" class="nyk-generic-button__icon-wrapper">
      <slot name="icon" />
    </span>
    <span v-if="$slots.default" class="nyk-generic-button__content">
      <slot />
    </span>
  </component>
</template>
